<template>
  <div class="body">
      <Headtow></Headtow>
      <Headfor></Headfor>

      <div id="w-center">
        <div class="index_pub_title">
            <p class="pub_d_title">书目下载区</p>
            <router-link :to="`/index`" class="pub_duo pub_duo_d">
               <i class="el-icon-house size-icon"></i> 首页>书目下载区
            </router-link>
            <div class="pub_xian"></div>
        </div>
        <ul class="yd_ul">
          <li class="tsg_li_ml"  v-for="(item, index) in list" @click="downloadFile(item.file)">
             <img src="/static/img/ydml.png" alt="" >
             <p class="ydml_title">{{item.title}}</p>
          </li>
        </ul>
      </div>
      <div class="h-15"></div>

      <div class="page">
        <!-- <el-pagination
          background
          layout="prev, pager, next"
          :page-size="12"
          :page-sizes="[100, 200, 300, 400]"
          @current-change="handleCurrentChange"
          :total="total">
        </el-pagination> -->

        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[20, 50,80,100]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>


      </div>


       <Foot></Foot>
  </div>

</template>

<script>
import headtow from '@/components/public/headtow.vue';
import headfor from '@/components/public/headfor.vue'
import foot from '@/components/public/foot.vue'
export default{
  data(){
    return {
      loading:true,

       list:[],
       page:1,
       total:0,
       size:20,
    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Headfor': headfor,
    'Foot': foot,
  },
  mounted(){
    this.id = this.$route.query.id;
    this.recordapi();
  },
  methods:{
    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/index/booklist",{'page':this.page,'keyword':this.keywords,'size':this.size}).then(res => {
          console.log(res);
          // that.types= res.type;
          // that.orderlist= res.orderlist;
          that.list= res.list.data;
          that.total = res.list.total

          that.loading = false
        });
    },
    handleSizeChange(val) {
       this.size = val
       console.log(val);
       this.recordapi();
    },

    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.recordapi();
    },

    downloadFile(fileName) {
      const fileUrl = fileName; // 文件的URL地址
      window.open("http://wfback.test1.dongbo.ren/"+fileUrl);
    }

  }

 }
</script>

<style scoped>
	.tsg_li_ml{width: 240px}
  .tsg_li:nth-child(3n){margin-right: 30px;}
   .tsg_li:nth-child(4n){margin-right: 0px;}
   .tsg_li_img{width: 100%;}
</style>




// WEBPACK FOOTER //
// src/components/Booklist.vue